<template>
    <div class="bg-lightest col-sm-12 py-4 mt-4">
        <div class="options d-flex align-items-center my-3">
            <!-- <search table="reservations"></search>

            <export :reservations="getReservations"></export> -->

            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-12">
                        <div class="row">

                            <div class="d-flex col-sm-4 pl-0">
                                <div class="d-flex w-100">
                                    <input class="bg-lighter flexGrow1" type="text" v-model="filters.searchString" placeholder="Search customer, ticket, voucher">
                                    <button class="btn wider blue ml-3 w-80" @click='getReservationsPaginated(true)'>Search</button>
                                    <!-- <div class="glued-left dark" @click='getReservationsPaginated'><i class="ico-search larger color-1"></i></div> -->
                                </div>
                            </div>

                            <div class="col-sm-4 d-flex pl-0">
                                <!-- <span class="d-flex mr-3" v-if="filters.eventId && filterEventName">
                                    <span class="wider bg-lighter darker glued-right font-weight-600">Event: {{filterEventName}}</span>
                                    <button class="btn wider color-6 bg-lighter border-top-light border-right-light border-bottom-light glued-left" @click='filters.eventId = null'>Remove</button>
                                </span> -->

                                <button class="btn wider bg-dark ml-1" v-if="getShowInvoiceOption === true && (getBulkSelectedIds.length > 0 || bulkSelectAll)" @click="openOptions">Invoice ({{bulkInvoiceTotal}})</button>

                            </div>

                            <div class="col-sm-4 d-flex justify-content-end align-items-center">
                                <div class="d-flex mr-4">

                                    <checkbox class="mr-3" v-model="filters.currentCheckboxNoCheckin" @input="resetPagination">
                                        <span class="white-space-nowrap">No Checkin</span>
                                    </checkbox>

                                    <checkbox class="mr-3" v-model="filters.currentCheckboxPickup" @input="resetPagination">
                                        <span class="white-space-nowrap">Pickups</span>
                                    </checkbox>

                                    <checkbox v-model="filters.currentCheckboxNote" @input="resetPagination">
                                        <span class="white-space-nowrap">Notes</span>
                                    </checkbox>
                                </div>
                                <export :exportOptions="exportOptions"></export>
                            </div>

                        </div>
                    </div>


                    <div class="col-sm-12 mt-3">
                        <div class="row d-flex align-items-start">

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getSlimFilters">
                                <!-- <v-select :searchable="true" :options="treatedProductList" label="name" placeholder="All" v-model="filterProduct" @input="changeProductFilter"></v-select> -->
                                <multiselect
                                    ref="productFilter"
                                    v-model="filters.productId"
                                    :options="treatedProductList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="All Products"
                                    label="name"
                                    track-by="id"
                                    :searchable="true"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    class="w-100"
                                >

                                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length > 1">{{ values.length }} products selected</span>
                                        <span class="multiselect__single" v-else-if="values.length == 1 ">{{values[0].name}} </span>
                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <i v-if="filters.productId.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                        <i v-else class="far fa-square"></i>
                                        <span>{{props.option.name}}</span>
                                    </template>

                                    <!-- <template slot="placeholder">

                                    </template> -->

                                </multiselect>

                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="treatedPaymentsStatusList && treatedPaymentsStatusList.length > 0">
                                <!-- <v-select :searchable="true" :options="treatedPaymentsStatusList" label="label" placeholder="All" v-model="filterPayment" @input="changePaymentStatusFilter"></v-select> -->

                                <multiselect
                                    ref="paymentStatusFilter"
                                    v-model="filters.paymentStatus"
                                    :options="treatedPaymentsStatusList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder=""
                                    label="label"
                                    track-by="id"
                                    :searchable="true"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    class="w-100"
                                >

                                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length > 1">{{ values.length }} payment status selected</span>
                                        <span class="multiselect__single" v-else-if="values.length == 1 ">{{values[0].label}} </span>
                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <i v-if="filters.paymentStatus.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                        <i v-else class="far fa-square"></i>
                                        <span>{{props.option.label}}</span>
                                    </template>

                                    <template slot="placeholder">
                                        Any Payment Status
                                    </template>

                                </multiselect>

                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="eventStatusList && eventStatusList.length > 0">
                                <!-- <v-select :searchable="true" :options="eventStatusList" label="description" placeholder="All" v-model="filterStatus" @input="changeStatusFilter"></v-select> -->

                                <multiselect
                                    ref="statusFilter"
                                    v-model="filters.status"
                                    :options="eventStatusList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder=""
                                    label="description"
                                    track-by="id"
                                    :searchable="true"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    class="w-100"
                                >

                                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length > 1">{{ values.length }} status selected</span>
                                        <span class="multiselect__single" v-else-if="values.length == 1 ">{{values[0].description}} </span>
                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <i v-if="filters.status.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                        <i v-else class="far fa-square"></i>
                                        <span>{{props.option.description}}</span>
                                    </template>

                                    <template slot="placeholder">
                                        Any Status
                                    </template>

                                </multiselect>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getSlimFilters">
                                <!-- <v-select :searchable="true" :options="treatedResourceList" label="name" placeholder="All" v-model="filterResource" @input="changeResourceFilter"></v-select> -->

                                <multiselect
                                    ref="resourceFilter"
                                    v-model="filters.resourceId"
                                    :options="treatedResourceList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder=""
                                    label="name"
                                    track-by="id"
                                    :searchable="true"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    class="w-100"
                                >

                                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length > 1">{{ values.length }} resources selected</span>
                                        <span class="multiselect__single" v-else-if="values.length == 1 ">{{values[0].name}} </span>
                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <i v-if="filters.resourceId.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                        <i v-else class="far fa-square"></i>
                                        <span>{{props.option.name}}</span>
                                    </template>

                                    <template slot="placeholder">
                                        Any Resource
                                    </template>

                                </multiselect>

                            </div>

                            <!-- <div class="col-md-2 d-flex flex-row align-items-center" v-if="editedAgentList && editedAgentList.length > 0">
                                <v-select v-model="selectedSeller" :options="editedAgentList" placeholder="All Agent/Sellers" :searchable="true" label="brandName" @input="updateSeller"></v-select>
                            </div> -->


                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="editedAgentList && editedAgentList.length > 0">
                                <seller-picker class="w-100" ref="sellerSelector" :allowEmpty="true" :inlcudeWidget="true" placeholder="All Sellers" @input="sellerChanged" @deselect="deselectSeller"></seller-picker>
                            </div>

                             <div class="col-md-2 d-flex flex-row align-items-center pl-0">
                                <button class="btn tertiary" @click='clearFilters'>Clear</button>

                                <!-- <div class="d-flex ml-2">
                                    <checkbox class="mr-3" v-model="filters.currentCheckboxPickup">
                                        Pickups
                                    </checkbox>

                                    <checkbox v-model="filters.currentCheckboxNote">
                                        Notes
                                    </checkbox>
                                </div> -->

                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center justify-content-end">


                            </div>


                        </div>
                    </div>

                </div>
            </div>



        </div>



        <!-- <div class="col-sm-12 d-flex justify-content-between my-4" v-if="pageInfo && reservationsArr.length > 0"> -->
        <div class="col-sm-12 d-flex justify-content-between my-4" v-if="allowSelectRows && pageInfo && reservationsArr.length > 0">
            <div class="bold dark">
                <span>Selected {{bulkInvoiceTotal}} of {{pageInfo.totalItemCount}}</span>
                <!-- <button class="btn tertiary small">Select entire page</button> -->
            </div>
            <div>
                <uib-pagination v-if="pageInfo.pageCount > 1" v-model="paginationComputed" :total-items="pageInfo.totalItemCount" :items-per-page="20" :boundary-link-numbers="false" :max-size="7" @change="getReservationsPaginated(false)"></uib-pagination>
            </div>
        </div>

        <list v-if="!isLoadingReservations && reservationsArr" :header="header" :body="body" :rows="reservationsArr" :showNoDataMessage="false"></list>

        <div class="col-sm-12 d-flex justify-content-end my-4" v-if="pageInfo && reservationsArr.length > 0">
            <uib-pagination v-if="pageInfo.pageCount > 1" v-model="paginationComputed" :total-items="pageInfo.totalItemCount" :items-per-page="20" :boundary-link-numbers="false" :max-size="7" @change="getReservationsPaginated(false)"></uib-pagination>
        </div>

        <div v-if="!isLoadingReservations && reservationsArr.length == 0" class="text-center p-4">
            <span class="dark font-weight-600 fs-large">No reservations were found.</span>
        </div>

        <div v-if="isLoadingReservations" class="p-4 my-4 text-center">
            <loader></loader>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Search from './Search'
    import List from '@/tools/list/baseList'
    import Loader from '@/tools/loaders/loader1'
    import VueDatepicker from 'vuejs-datepicker'
    import extendedVSelect from '@/extends/vue-select'
    import {eventHub} from '../../main'
    import Export from '@/tools/ExportV2'
    import SellerPicker from '@/tools/SellerPicker'
    import Multiselect from 'vue-multiselect'

    import mixpanelMixin from '@/mixins/mixpanel'

    // columns
    import iconsColumn from './reservationLists/columns/icons'

    export default {
        mixins: [
            mixpanelMixin
        ],
        data: function() {
            return {
                reservationsArr: [],
                isLoadingReservations: false,
                // pagination:{
                //     currentPage: 1,
                // },
                pageInfo: null,
                filters:{
                    searchString: null, // string
                    productId: [], // int
                    resourceId: [], // int
                    paymentStatus: [], // int
                    agentId: null, // int
                    userId: null, // int
                    status: [], // int
                    supplierId: null, // int
                    eventId: null, // int
                    currentCheckboxNoCheckin: false,
                    currentCheckboxPickup: false,
                    currentCheckboxNote: false,
                    channelType: null // int 100 = widget
                },
                exportOptions: [
                    {
                        label: 'Excel',
                        action: this.getExcel
                    }
                ],
                // transportList:[
                //     {
                //         name:'With and without transport',
                //         value:null,
                //     },
                //     {
                //         name: 'Without transport',
                //         value: false
                //     },
                //     {
                //         name: 'With transport',
                //         value: true
                //     },
                // ],
                filterPayment: {
                    id:null,
                    label:'Any Payment Status'
                },
                filterStatus: {
                    id:null,
                    description:'Any Status'
                },
                filterProduct: {
                    id:null,
                    name:'All Products'
                },
                filterResource: {
                    id:null,
                    name:'All Resources'
                },
                filterTransport: {
                    value:null,
                    name:'With and without transport'
                },
                selectedSeller: {
                    id: null,
                    brandName: 'All Agent/Seller'
                },
                notesAndPickupsOptions: [
                    {
                        name: 'Notes and Pickups',
                        id: 0,
                    },
                    {
                        name: 'Notes included',
                        id: 1,
                    },
                    {
                        name: 'Pickups included',
                        id: 2,
                    },
                    {
                        name: 'All',
                        id: 3,
                    },
                ],
                selectedNotesAndPickups: {
                    name: 'Notes and Pickups',
                    id: 0
                },
                bulkSelectAll: false,
                selectedReservationIds: [],
            }
        },
        created: function() {
            //clears the bulkSelectedIds array on the store
            this.setBulkSelectedIds([])

            //gets reservations of a given event (id)
            if(this.getSelectedEventListReservations){
                this.filters.eventId = this.getSelectedEventListReservations.id
                // this.setSelectedEventListReservations(null)
            }

            // console.log('running created - Reservation Dates');
            this.getReservationsPaginated(false)

            eventHub.$off('updateReservationsList');
            eventHub.$on('updateReservationsList',(data) => {
                if(this.reservationMainFilters.selectedView.id != 1){
                    return false
                }

                console.log('updateReservationsList C', this.reservationMainFilters, data);
                //if data is an object or array
                if(data.id){

                    //set row as loading
                    this.reservationsArr.map(reservationEntryOnList => {
                        if(reservationEntryOnList.id == data.id){
                            this.$set(reservationEntryOnList, 'loading', true)
                        }
                    })

                } else {
                    //if its no and object it should be an array

                    for (let reservationEntryOnList of this.reservationsArr) {

                        for(let bulkId of data){
                            if(reservationEntryOnList.id == bulkId){
                                this.$set(reservationEntryOnList, 'loading', true)

                            }
                        }

                    }

                }


                this.getReservationsPaginated(false)
            });

            this.eventHub.$on('clearReservationFilters', data => {
                this.clearFilters()
            })

            //check if we have supplier info (need supplierId to get the agent list),
            // then gets the agents
            // if(!this.account.account){
            //     this.refreshAccountData().then(response => {
            //         this.initAgents()
            //     })
            // } else {
                // this.initAgents()
            // }


        },
        props: {
            reservationMainFilters: {
                type: Object,
                default: null
            },
            pagination: {
                type: Object
            }
        },
        watch: {
            'reservationMainFilters':{
                handler: function (val, oldVal) {
                    //if props change (the range date for example)
                    this.getReservationsPaginated(true)
                },
                deep: true
            },
            'filters':{
                handler: function (val, oldVal) {
                    console.log('FILTERS CHANGED');
                    this.getReservationsPaginated(true)
                },
                deep: true
            },
            'getSelectedEventListReservations':{
                handler: function (newVal, oldVal) {
                    if(this.getSelectedEventListReservations){
                        this.filters.eventId = this.getSelectedEventListReservations.id
                    } else {
                        this.filters.eventId = null
                    }
                    this.getReservationsPaginated(true)
                }
            }
        },
        computed: {
            ...mapGetters([
                // 'getReservations',
                'getReservationsLabels',
                'account',
                'getEventReservations',
                'getAgents',
                'getSlimFilters',
                'getReservionStates',
                'getSelectedEventListReservations',
                'getPaymentsStatusList',
                'getBulkSelectedIds',
                'getShowInvoiceOption',
                // 'getAllReservationStates',
                'getReservationState'
            ]),
            allowSelectRows: function () {
                return this.getShowInvoiceOption
            },
            bulkInvoiceTotal: function () {
                return this.getBulkSelectedIds.length
                // if(this.bulkSelectAll == true){
                //     return this.pageInfo.totalItemCount
                //     // return 'All ' + this.pageInfo.totalItemCount
                // } else {
                //     return this.getBulkSelectedIds.length
                // }
            },
            treatedProductList: function() {
                let output = JSON.parse(JSON.stringify(this.getSlimFilters.productList));

                // output.unshift({
                //     id:null,
                //     name:'All Products'
                // })
                return output
            },
            treatedResourceList: function() {
                let output = JSON.parse(JSON.stringify(this.getSlimFilters.resourceList));

                // output.unshift({
                //     id:null,
                //     name:'All Resources'
                // })
                return output
            },
            treatedPaymentsStatusList: function() {
                let output = JSON.parse(JSON.stringify(this.getPaymentsStatusList));

                // output.unshift({
                //     id:null,
                //     label:'Any Status'
                // })
                return output
            },
            requestFilterOptions: function() {
                return {
                    's.String': this.filters.searchString,
                    's.ProductId': this.filters.productId && this.filters.productId.length > 0? this.filters.productId.map(item => item.id) : null,
                    's.ResourceId': this.filters.resourceId && this.filters.resourceId.length > 0? this.filters.resourceId.map(item => item.id) : null,
                    's.agentId': this.filters.agentId,
                    's.userAccountId': this.filters.userId,
                    's.PaymentStatus': this.filters.paymentStatus && this.filters.paymentStatus.length > 0? this.filters.paymentStatus.map(item => item.id) : null,
                    's.StatusList': this.filters.status && this.filters.status.length > 0 ? this.filters.status.map(item => item.id) : null,
                    supplierId: this.account.supplierId,
                    's.isNoFullCheckin': this.filters.currentCheckboxNoCheckin? true : null,
                    's.withTransport': this.filters.currentCheckboxPickup? true : null,
                    's.withNote': this.filters.currentCheckboxNote? true : null,
                    's.eventId': this.filters.eventId,
                    's.EventDateStartStart': (this.filters.eventId)? null : this.reservationMainFilters.dateRange[0],
                    's.EventDateStartEnd': (this.filters.eventId)? null : this.reservationMainFilters.dateRange[1],
                    's.channelType': this.filters.channelType,
                    page: this.pagination.currentPage,
                    pageSize: 20
                }
            },
            header: function() {
                let vm = this
                return {
                    selection: {
                        active: this.allowSelectRows,
                        event: function(event) {
                            console.log('selecte all', event);
                            vm.bulkSelectAll = event
                            vm.selectCurrentPage(event)
                        }
                    },
                    selectAll: this.bulkSelectAll,
                    list: {
                        reservation: 'Reservation',
                        resource: 'Resource',
                        departure: 'Departure',
                        //created: 'Created',
                        pax: 'PAX',
                        totalPrice: 'Total',
                        status: 'Status',
                        fullName: 'Client Name',
                        seller: 'Seller',
                        extras: 'Extras',
                        checkin: 'Check|NoShow',
                        //noshow: 'No Show',
                        icons: ' ',
                    },
                    customClassCell: {
                    },
                };
            },
            body: function() {
                let vm = this;

                return {
                    selection: {
                        active: this.allowSelectRows,
                        event: function(event, reservation) {
                            console.log('vm.getBulkSelectedIds', vm.getBulkSelectedIds);
                            if(vm.getBulkSelectedIds.length > 0 && vm.getBulkSelectedIds.includes(reservation.id)){
                                console.log('a - '+reservation.id);
                                vm.removeFromBulkSelectedIds([reservation.id])
                            } else {
                                console.log('b - '+reservation.id);
                                vm.addToBulkSelectedIds([reservation.id])
                            }

                            // vm.setBulkSelectedIds(JSON.parse(JSON.stringify(vm.selectedReservationIds)))

                        }
                    },
                    customRowEvent: function(reservation) { vm.view(reservation.id)},
                    customCells: {
                        reservation: function(reservation) {
                            if(reservation.event.product){
                                const p = reservation.event.product;
                                return vm.multiLevelHtml(vm.formatTicketNumber(reservation.id), p.name);
                            } else {
                                return 'missing'
                            }
                        },
                        resource: function (reservation) {
                            return reservation.selectedResource? reservation.selectedResource.name : ''
                        },
                        departure: function(reservation) {
                            return vm.formatDateDots(reservation.eventDate)+'<br>'+vm.formatTime(reservation.eventDate)
                        },
                        created: function(reservation) {
                            return vm.formatDateDots(reservation.reservationDate)+'<br>'+vm.formatTime(reservation.reservationDate)
                        },
                        pax: function(reservation) {
                             return reservation.paxTotal;
                        },
                        totalPrice: function(reservation) {
                            return reservation.billingTotal ? vm.formatPrice(reservation.billingTotal)+'€' : '-';
                        },
                        // status: function(reservation){
                        //     if(reservation.loading){
                        //         return '<div class="loaderHolder"><div class="loader">Loading...</div></div>'
                        //     } else if(reservation.status == 1){
                        //         if(reservation.billingInDue > 0){
                        //             return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-5 radius-stadium text-center font-weight-600">IN DUE</div><div class="pt-1 text-center fs-smaller">'+ vm.formatPrice(reservation.billingInDue) +'€</div></div>'
                        //         } else if (reservation.billingInDue < 0) {
                        //             return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-5 radius-stadium text-center font-weight-600">OVERPAID</div><div class="pt-1 text-center fs-smaller">'+ vm.formatPrice(reservation.billingInDue) +'€</div></div>'
                        //         } else {
                        //             return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-3 radius-stadium text-center font-weight-600">PAID</div></div>'
                        //         }
                        //     } else if(reservation.status == -100) {
                        //         return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-6 radius-stadium text-center font-weight-600">STRIPE_ERROR</div></div>'
                        //     } else if(reservation.status == -5) {
                        //         return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-dark radius-stadium text-center font-weight-600">CANCELED</div></div>'
                        //     } else if(reservation.status == 30) {
                        //         return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-2 radius-stadium text-center font-weight-600">REBOOKED</div></div>'
                        //     } else if(reservation.status == 20) {
                        //         return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-2 radius-stadium text-center font-weight-600">Rebooked → TO</div></div>'
                        //     } else if(reservation.status == 5) {
                        //         return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-1 radius-stadium text-center font-weight-600">PENDING</div></div>'
                        //     }
                        // },
                        status: (reservation) => {
                            if(reservation.loading){
                                return '<div class="loaderHolder"><div class="loader">Loading...</div></div>'
                            } else if(reservation.status == 1){
                                if(reservation.paymentStatus == 1){
                                    return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-3 radius-stadium text-center text-uppercase font-weight-600">'+reservation.paymentStatusDescription+'</div></div>'
                                } else if (reservation.paymentStatus == 0) {
                                    return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-5 radius-stadium text-center text-uppercase font-weight-600">'+reservation.paymentStatusDescription+'</div><div class="pt-1 text-center fs-smaller">'+ vm.formatPrice(reservation.billingInDue) +'€</div></div>'
                                } else if (reservation.paymentStatus == 2) {
                                    return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-5 radius-stadium text-center text-uppercase font-weight-600">'+reservation.paymentStatusDescription+'</div><div class="pt-1 text-center fs-smaller">'+ vm.formatPrice(reservation.billingInDue) +'€</div></div>'
                                } else {
                                    // return '<div class=""><div class="lightest fs-smallest px-2 py-1 bg-color-3 radius-stadium text-center font-weight-600">PAID</div></div>'
                                    return ''
                                }
                            } else {
                                return `<div class=""><div class="lightest fs-smallest px-2 py-1 text-uppercase ${vm.getReservationState(reservation.status).cssClass} radius-stadium text-center font-weight-600">${vm.getReservationState(reservation.status).label}</div></div>`
                            }
                        },
                        fullName: function(reservation) {
                            const c = reservation.customer;
                            return (c.name !== undefined && c.surname !== undefined) ? c.name + ' ' + c.surname : '-';
                        },
                        seller: function(reservation) {
                            if(reservation.channelType >= 100 && reservation.channelType <= 102){
                                return 'Widget'
                            } else if(reservation.channelType == 201){
                                return 'Pluralo Locals'
                            } else if(reservation.channelType == 202){
                                return 'Get Your Guide'
                            } else {
                                return reservation.creatorAgent? reservation.creatorAgent.brandName + ' (Agent)' : reservation.creatorUserAccount? reservation.creatorUserAccount.name : ''
                            }
                        },
                        extras: function (reservation) {
                            if(reservation.bookingComponents.length > 0){

                                //group componets
                                let existingGroup = JSON.parse(JSON.stringify(reservation.bookingComponentsGrouped))
                                let groupedComponents = []

                                existingGroup.map(existingItem => {
                                    let itemIsGrouped = groupedComponents.find(groupedItem => {
                                        return groupedItem.component.id == existingItem.component.id
                                    })


                                    if(!itemIsGrouped){
                                        groupedComponents.push(existingItem)
                                    } else {
                                        itemIsGrouped.quantity += existingItem.quantity
                                    }

                                })


                                let output = ''
                                for (let extra of groupedComponents) {
                                    if(extra.quantity > 0){
                                        output += '<div>'+extra.quantity+' - '+(extra.component && extra.component.name)? extra.component.name :'' +' '+(extra.componentPrice && extra.componentPrice.name)? extra.componentPrice.name: '' +'</div>'
                                    }
                                }

                                return output
                            } else {
                                return ''
                            }

                        },
                        checkin: function(reservation) {
                            return reservation.paxCheckedIn + '|' + reservation.paxNoShow ;
                        },
                        icons: function(reservation) {
                            return {
                                component: iconsColumn,
                                arguments: reservation
                            }
                        },
                    },
                    customClassCell: {
                        reservation : 'pointer',
                        created : 'pointer',
                        pax : 'pointer',
                        totalPrice : 'pointer',
                        fullName : 'pointer',
                        seller : 'pointer',
                        status : 'pointer',
                        checkin : 'pointer',
                        noshow : 'pointer',
                    },
                    // rowEvent: this.view(event)
                }
            },
            productsList: function(){
                let outputArr = [];

                this.getReservations.forEach(function(reservation){
                    if(reservation.event.product && outputArr.indexOf(reservation.event.product.name) == -1){
                        outputArr.push(reservation.event.product.name)
                    }
                });

                return outputArr;
            },
            agentMe: function() {
                return {brandName: this.account.name + ' (Me)', name: null}
            },
            editedAgentList: function() {
                let agentList = JSON.parse(JSON.stringify(this.getAgents));


                let agentMustHaveName = agentList.filter(agent => {
                    return agent.name != null
                })

                agentMustHaveName.unshift(this.agentMe)
                agentMustHaveName.unshift({
                    id: null,
                    brandName: 'All Sellers'
                })

                return agentMustHaveName;
            },
            eventStatusList: function() {
                let output = JSON.parse(JSON.stringify(this.getReservionStates));

                // output.unshift({
                //     description: "Any Status",
                //     id: null
                // })

                return output
            },
            paginationComputed: {
                get: function () {
                    return this.pagination
                },
                set: function(newValue) {
                    this.$emit('paginationChanged', newValue)
                    // this.getReservationsPaginated()
                    // console.log(pagination);
                }
            }
        },
        methods: {
            ...mapActions([
                'addReservation',
                'refreshAccountData',
                'setSelectedReservation',
                'setEventReservations',
                'openModal',
                'pushReservationToStore',
                // 'initAgents',
                'refreshAccountData',
                'setBulkSelectedIds',
                'addToBulkSelectedIds',
                'removeFromBulkSelectedIds',
                'setSelectedEventListReservations',
                'getEventFromId',
                'setReservationListFilters',
                'setReservationListAllSelected',
            ]),
            stateTranslate: function (code) {
                return 'b'
            },
            clearFilters: function() {
                // alse clear the selection
                this.selectAllReservations(false)
                this.setBulkSelectedIds([])

                this.filters = {
                    productId: [],
                    resourceId: [],
                    paymentStatus: [],
                    agentId: null, // int
                    status: [], // int
                    userId: null, // int
                    supplierId: null, // int
                    eventId: null, // int
                    currentCheckboxNoCheckin: false,
                    currentCheckboxPickup: false,
                    currentCheckboxNote: false,
                }

                this.filterStatus = null

                this.filterPayment = null

                this.selectedSeller = null

                this.filterProduct = null

                // clear multiSelects search
                this.$refs.productFilter.search = ""
                this.$refs.paymentStatusFilter.search = ""
                this.$refs.statusFilter.search = ""
                this.$refs.resourceFilter.search = ""

                // this.filterTransport = {
                //     id:null,
                //     name:'With and without transport'
                // },

                this.getReservationsPaginated(false)
                if(this.$refs.sellerSelector){
                    this.$refs.sellerSelector.deselectSeller()
                }

                this.resetPagination()
            },
            formatMoney: function(value) {
                return parseFloat(value).toFixed(2) + '€';
            },
            pageChanged: function(){
                console.log('page changed');
                this.getReservationsPaginated(false)
            },
            getReservationsPaginated: _.debounce(
                // _.debounce is a function provided by lodash to limit how
                // often a particularly expensive operation can be run.
                // In this case, we want to limit how often we access
                // yesno.wtf/api, waiting until the user has completely
                // finished typing before making the ajax request. To learn
                // more about the _.debounce function (and its cousin
                // _.throttle), visit: https://lodash.com/docs#debounce
                function(userFiltered) {
                    this.$set(this, 'bulkSelectAll', false)

                    console.log('userFiltered', userFiltered);
                    let vm = this
                    // this.selectAllReservations(false)
                    if(!this.isLoadingReservations){
                        this.isLoadingReservations = true
                        axios.get('/api/booking/DeparturesList',{
                            params: this.requestFilterOptions
                        }).then(response => {
                            //sets the select all as false when changing pages
                            // vm.bulkSelectAll = false


                            vm.isLoadingReservations = false
                            if(response.status == 200){

                                vm.pageInfo = response.data.pageInfo;
                                vm.reservationsArr = vm.selectSelectedReservations(response.data.result);

                                // mixpanel
                                if(userFiltered){
                                    // vm.$ma.trackEvent({action:'Filtered Reservations By Departure Date', properties: vm.requestFilterOptions})
                                    vm.trackFilter('Filtered Reservations','Departure Date', vm.requestFilterOptions)
                                    // console.log('sending this to mixpanel', {action:'Filtered Reservations By Departure Date', properties: vm.requestFilterOptions});
                                }
                            }
                        }).catch(e => {
                            vm.isLoadingReservations = false
                        })
                    }
                },
                500
            ),
            deselectAllRows: function () {
                this.selectAllReservations(false)
                this.selectedReservationIds = []
                // this.bulkSelectAll = false
                this.$set(this, 'bulkSelectAll', false)
                this.setBulkSelectedIds([])
            },
            selectCurrentPage: function (selectVal) {
                console.log('selectCurrentPage', selectVal);
                let currentPageAllIds = []
                let vm = this
                this.reservationsArr.map(row => {
                    this.$set(row, 'selected', selectVal)
                    currentPageAllIds.push(row.id)
                })
                this.$set(this, 'selectedReservationIds', currentPageAllIds)
                if(selectVal == true){// output.unshift({
                //     description: "Any Status",
                //     id: null
                // })
                    this.addToBulkSelectedIds(this.selectedReservationIds)
                } else {
                    this.removeFromBulkSelectedIds(this.selectedReservationIds)
                }
            },
            multiLevelHtml: function(top, bottom) {
                return '<div><b>' + top + '</b></div><div class="sub">' + bottom + '</div>';
            },
            view: function(ticketNr) {
                let vm = this;
                axios.get('api/reservation/FindReservationBySupplier', {
                    params: {
                        supplierId: vm.account.supplierId,
                        reservationId: ticketNr
                    }
                }).then((response) => {
                    if(response !== null && response !== undefined && response.status == 200){
                        if(response.data !== null){
                            //ticket exists
                            // vm.updateClonedReservation(response.data);
                            // vm.triggerModal(Number(vm.ticketNr), 'ReservationView');
                            // this.$router.push('/reservations')
                            this.pushReservationToStore(response.data)
                            this.triggerModal(response.data, 'ReservationEdit');
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            triggerModal: function(reservation, modal) {
                this.setSelectedReservation(reservation);
                this.openModal(modal);
            },
            changePaymentStatusFilter: function() {
                this.resetPagination()
                if(this.filterPayment){
                    this.filters.paymentStatus = this.filterPayment.id
                } else {
                    this.filters.paymentStatus = null
                    this.filterPayment = {
                        id:null,
                        label:'Any Payment Status'
                    }
                }
            },
            resetPagination: function () {
                this.$emit('resetPagination')
            },
            changeStatusFilter: function() {
                this.resetPagination()
                if(this.filterStatus){
                    this.filters.status = this.filterStatus.id
                } else {
                    this.filters.status = null
                    this.filterStatus = {
                        id:null,
                        description:'All Status'
                    }
                }
            },
            changeTransportFilter: function() {
                if(this.filterTransport){
                    this.filters.withTransport = this.filterTransport.value
                } else {
                    this.filters.withTransport = null
                    this.filterTransport = {
                        id:null,
                        name:'With and without transport'
                    }
                }
            },
            changeProductFilter: function() {
                this.resetPagination()
                if(this.filterProduct){
                    this.filters.productId = this.filterProduct.id
                } else {
                    this.filters.productId = null
                    this.filterProduct = {
                        id:null,
                        name:'All Products'
                    }
                }

            },
            changeResourceFilter: function() {
                this.resetPagination()
                if(this.filterResource){
                    this.filters.resourceId = this.filterResource.id
                } else {
                    this.filters.resourceId = null
                    this.filterResource = {
                        id:null,
                        name:'All Resources'
                    }
                }
            },
            updateSeller: function() {
                if(this.selectedSeller){
                    this.filters.agentId = this.selectedSeller.id
                } else {
                    this.filters.agentId = null
                    this.selectedSeller = {
                        id: null,
                        brandName: 'All Sellers'
                    }
                }
            },
            getExcel: function() {
                axios.get('/api/booking/DeparturesDownload', {
                    params: this.requestFilterOptions,
                    responseType: 'blob'
                }).then(response => {
                    if (response.status == 200) {

                        window.URL = window.URL || window.webkitURL;
                        const headers = response.headers;
                        const blob = new Blob([response.data],{type:headers['content-type']});
                        const link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = window.URL.createObjectURL(blob);
                        let namePrefix = ''
                        if(this.reservationMainFilters.dateRange[0] && this.reservationMainFilters.dateRange[1]){
                            namePrefix = moment(this.reservationMainFilters.dateRange[0]).format('YYYY-MM-DD') + '_' + moment(this.reservationMainFilters.dateRange[1]).format('YYYY-MM-DD') + '_'
                        }
                        link.download = namePrefix + 'departures.xlsx';
                        link.click();

                        //
                        // var link = document.createElement('a');
                        // // Add the element to the DOM
                        // link.setAttribute("type", "hidden"); // make it hidden if needed
                        // link.href = 'data:application/vnd.ms-excel;utf-8,test';
                        // document.body.appendChild(link);
                        // link.click();
                        // link.remove();

                    }
                })
            },
            selectSelectedReservations: function(reservations) {
                let newBulkSelectAll = reservations.length > 0
                for (let reservation of reservations) {
                    if(this.getBulkSelectedIds.includes(reservation.id)){
                        this.$set(reservation, 'selected', true)
                    } else {
                        newBulkSelectAll = false

                    }

                }
                this.bulkSelectAll = newBulkSelectAll

                return reservations
            },
            selectAllReservations: function(state) {
                this.setReservationListAllSelected(state)
                for (let reservation of this.reservationsArr) {
                    this.$set(reservation, 'selected', state)

                    //if adding to selection
                    if(state){
                        if(this.selectedReservationIds.indexOf(reservation.id) == -1){
                            this.selectedReservationIds.push(reservation.id)
                        }
                    } else {
                        //if removing from selection
                        if(this.selectedReservationIds.indexOf(reservation.id) != -1){
                            this.selectedReservationIds.splice(this.selectedReservationIds.indexOf(reservation.id), 1)
                        }
                    }
                }
            },
            openOptions: function() {
                this.setReservationListFilters(this.requestFilterOptions)
                this.openModal('ReservationsBulkActions');
            },
            sellerChanged: function(e) {
                this.resetPagination()
                if(e.userAccountTypes){
                    console.log('My team member');
                    this.$set(this.filters, 'userId', e.id)
                    this.$set(this.filters, 'agentId', null)
                    this.$set(this.filters, 'channelType', null)
                } else if(e.channelType) {
                    console.log('is Channel');
                    this.$set(this.filters, 'channelType', e.channelType)
                    this.$set(this.filters, 'userId', null)
                    this.$set(this.filters, 'agentId', null)
                    return true
                } else if(e.isAllSellers) {
                    console.log('is all sellers');
                    this.$set(this.filters, 'userId', null)
                    this.$set(this.filters, 'agentId', null)
                    this.$set(this.filters, 'channelType', null)
                    this.selectedSeller = {
                        id: null,
                        brandName: 'All Sellers'
                    }
                    return true
                } else {
                    console.log('is Agent');
                    this.$set(this.filters, 'userId', null)
                    this.$set(this.filters, 'agentId', e.id)
                    this.$set(this.filters, 'channelType', null)
                }

                this.getReservationsPaginated(false)

            },
            deselectSeller: function() {
                this.filters.userId = null
                this.filters.agentId = null
                this.filters.channelType = null
            }
         },
        components: {
            List,
            Loader,
            Search,
            Export,
            vSelect: extendedVSelect,
            // extendedvSelect: extendedVSelect,
            VueDatepicker,
            Export,
            SellerPicker,
            Multiselect,
        }
    }
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';
@import '../../assets/scss/_utility.scss';

//loader ! This is used on other places like on PeopleAgents.vue (agents list)
.loaderHolder{
    background: #C5D0DE;
    padding: 7px;
    width: 52px;
    @extend .radius-normal;
    // margin: auto;
}

.loader,
.loader:before,
.loader:after {
    border-radius: 50%;
    width: 1em;
    height: 1em;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation: load7 1.8s infinite ease-in-out;
    animation: load7 1.8s infinite ease-in-out;
}
.loader {
    color: #8CA0B3;
    font-size: 10px;
    // margin: 1px auto;
    position: relative;
    text-indent: -9999em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}
.loader:before,
.loader:after {
    content: '';
    position: absolute;
    top: 0;
}
.loader:before {
    left: -1.3em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}
.loader:after {
    left: 1.3em;
}
@-webkit-keyframes load7 {
    0%,
    80%,
    100% {
        box-shadow: 15px 0 0 -1.3em;
    }
    40% {
        box-shadow: 15px 0 0 0;
    }
}
@keyframes load7 {
    0%,
    80%,
    100% {
        box-shadow: 15px 0 0 -1.3em;
    }
    40% {
        box-shadow: 15px 0 0 0;
    }
}
</style>



// WEBPACK FOOTER //
// ReservationsByDepartureDate.vue?a081dde4